// src/componentes/Propiedades/NuevoFraccionamiento.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { collection, addDoc, getDocs, Timestamp } from "firebase/firestore";
import { db } from "../../Firebase/firebaseconfig";
import { nextFolioPropiedad } from "../../helpers/folio";
import { buildPropDoc } from "../../helpers/propiedad";
import { buildPropSearchFields } from "../../helpers/propIndex";
import notify from "../common/notify";

const NuevoFraccionamiento = () => {
  const navigate = useNavigate();

  const [fraccionamientos, setFraccionamientos] = useState([]);
  const [selectedFraccId, setSelectedFraccId] = useState("");

  const [form, setForm] = useState({
    manzana: 1,
    lotes: 10,
    metros2: 100,
    precioContado: 100000,
    precioFinanciado: 100000,
    tipo: "Terreno",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [progress, setProgress] = useState({ done: 0, total: 0 });

  useEffect(() => {
    (async () => {
      const snap = await getDocs(collection(db, "fraccionamientos"));
      setFraccionamientos(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    })();
  }, []);

  const selectedFracc = fraccionamientos.find(f => f.id === selectedFraccId) || null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    if (!selectedFracc) {
      notify.error("Selecciona un fraccionamiento existente.");
      return;
    }
    if (!form.manzana || !form.lotes) {
      notify.error("Manzana y número de lotes son obligatorios.");
      return;
    }

    setIsSubmitting(true);
    setProgress({ done: 0, total: Number(form.lotes) });

    try {
      const fraccionamientoId = selectedFracc.id;
      const fraccNombre = selectedFracc.nombre || "";
      const fraccUbicacion = selectedFracc.ubicacion || "";

      const manzanaInt = Number(form.manzana);
      const lotesInt = Number(form.lotes);
      const metros2 = Number(form.metros2 || 0);
      const precioContado = Number(form.precioContado || 0);
      const precioFinanciado = Number(form.precioFinanciado || 0);

      for (let lt = 1; lt <= lotesInt; lt++) {
        const { folio } = await nextFolioPropiedad();

        const base = {
  folio,
  tipo: form.tipo,
  fraccionamientoId,
  fraccNombre,
  manzana: manzanaInt,
  lote: lt,
  metros2,
  precioContado,
  precioFinanciado,
  ubicacion: `Mz ${manzanaInt} Lt ${lt}, ${fraccUbicacion}`,
};

// Datos base de la propiedad
let docData = {
  folio,
  ...buildPropDoc(base),
  nombre: `${fraccNombre} Mz ${manzanaInt} Lt ${lt}`,
  notas: "",
  creado: Timestamp.now(),
  actualizado: Timestamp.now(),
  disponible: true,
  activo: true,
  asociadaADeuda: false,
  bitacora: [
    {
      ts: Timestamp.now(),
      tipo: "creacion_batch",
      detalle: `Alta ${folio}`,
      userId: null,
    },
  ],
};

// 🔥 Índices de búsqueda (ngram, tokens, claveLote, manzanaInt/loteInt)
const idx = buildPropSearchFields({
  ...docData,
  fraccionamientoNombre: fraccNombre,
});

docData = {
  ...docData,
  ...idx,
};

await addDoc(collection(db, "propiedades"), docData);
        setProgress(prev => ({ ...prev, done: prev.done + 1 }));
      }

      notify.success("Manzana y lotes creados correctamente");
      navigate("/app/propiedades");
    } catch (err) {
      console.error("Error al crear lotes:", err);
      notify.error("Ocurrió un error al crear la manzana y sus lotes.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="nuevo-cliente-container">
      <h2>Alta de Manzana</h2>

      <form onSubmit={handleSubmit} className="form-cliente" style={{ display: "grid", gap: 8 }}>
        <label>Selecciona fraccionamiento
          <select
            value={selectedFraccId}
            onChange={(e) => setSelectedFraccId(e.target.value)}
            required
          >
            <option value="">-- Selecciona --</option>
            {fraccionamientos.map(f => (
              <option key={f.id} value={f.id}>{f.nombre} — {f.ubicacion}</option>
            ))}
          </select>
        </label>
        {selectedFracc ? (
          <small style={{ opacity: 0.8 }}>
            <strong>Ubicación:</strong> {selectedFracc.ubicacion || "-"} · <strong>Estado:</strong> {selectedFracc.estado || "-"}
          </small>
        ) : null}

        <label>Tipo de propiedad (para todos los lotes)
          <input name="tipo" value={form.tipo} onChange={handleChange} />
        </label>

        <label>Número de manzana a registrar
          <input name="manzana" type="number" value={form.manzana} onChange={handleChange} required />
        </label>

        <label>Número de lotes en esta manzana
          <input name="lotes" type="number" value={form.lotes} onChange={handleChange} required />
        </label>

        <label>Metros cuadrados por lote
          <input name="metros2" type="number" value={form.metros2} onChange={handleChange} required />
        </label>

        <div style={{ display: "grid", gap: 8, gridTemplateColumns: "1fr 1fr" }}>
          <label>Precio contado por lote (MXN)
            <input name="precioContado" type="number" value={form.precioContado} onChange={handleChange} required />
          </label>
          <label>Precio financiado por lote (MXN)
            <input name="precioFinanciado" type="number" value={form.precioFinanciado} onChange={handleChange} required />
          </label>
        </div>

        <div style={{ display: "flex", gap: 8, marginTop: 8, flexWrap: "wrap" }}>
          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? `Generando ${progress.done}/${progress.total}…` : "Crear Manzana y Lotes"}
          </button>
          <button
            type="button"
            onClick={() => navigate(-1)}
            disabled={isSubmitting}
            style={{
              background: "#f1f5f9",
              color: "#1e293b",
              border: "1px solid #cbd5e1",
            }}
          >
            Cancelar
          </button>
        </div>
      </form>
    </div>
  );
};

export default NuevoFraccionamiento;
